import React, { useContext } from 'react';
import {
    Label, PasswordInput, Heading, Alert,
    Collapsible,
    CollapsibleHeading,
    CollapsibleContent,
    IconDataProtection, dlsBrightBlue
} from '@americanexpress/dls-react';
import UserContext from '../../components/ContextComponent/UserContext';
import { CONSTANTS } from '../../constants';

function CardPin() {
    const { formData, setFormData } = useContext(UserContext);
    const { errorData, setErrorData } = useContext(UserContext);

    const handlePinBlur = (e) => {
        setFormData(prev => {return { ...prev, createCardPin: e.target.value }});

        if (!CONSTANTS.validation.pinPattern.test(e.target.value) || e.target.value.length < 4) {
            setErrorData(prev => {return { ...prev, cardPinRequired: true }});
        }
        else {
            setErrorData(prev => {return { ...prev, cardPinRequired: false }});
        }

        // When Confirm pin is entered first and then pin is enetered
        if (formData.confirmCardPin !== '' && formData.confirmCardPin !== e.target.value) {
            setErrorData(prev => {return { ...prev, confirmCardPinRequired: true }});
        }
        else {
            if (formData.confirmCardPin === '' && errorData.confirmCardPinRequired !== true)
                setErrorData(prev => {return { ...prev, confirmCardPinRequired: false }});
        }
    }

    const handleCPinBlur = (e) => {
        setFormData(prev => {return {...prev, confirmCardPin: e.target.value}});

        if (!CONSTANTS.validation.pinPattern.test(e.target.value) || e.target.value.length < 4 || formData.createCardPin !== e.target.value)
        {
            setErrorData(prev => {return { ...prev, confirmCardPinRequired: true }});
        }
        else {
            setErrorData(prev => {return { ...prev, confirmCardPinRequired: false }});
        }
    }

    const pinKeyPressHandler = (e) => {
        if (!CONSTANTS.validation.pinPattern.test(e.key)) {
            e.preventDefault();
        }
    }
    return (
        <div className="margin-4-t stack">
            <div className="flex margin-2-t">
                <IconDataProtection theme={dlsBrightBlue} filled={true} title="accessibility icon" size="md"/>
                <Heading level="3" className="margin-2-b heading-3 text-uppercase margin-1-l">
                    Create a Personal Identification Number (PIN) for your Card
                </Heading>
            </div>
            <div>
                <Collapsible>
                    Create a secret, secure and memorable 4-digit Personal Identification Number&nbsp; 
                    <CollapsibleHeading
                        id="collapsible-text-h1"
                        theme={{
                            '&:hover': {
                                textDecoration: 'underline'
                            },
                            color: '#006fcf'
                        }}
                    >
                        (When you'll need your PIN)
                    </CollapsibleHeading>.
                    <CollapsibleContent labelledBy="collapsible-text-h1">
                        <p className="pad">
                            The Personal Identification Number (PIN) secures from any unauthenticated transactions as all
                            withdrawals, online transactions and POS transactions are completed only after entering the
                            unique 4 digit PIN.
                            <CollapsibleHeading
                                forId="collapsible-text-h1"
                                id="hide-collapisble-text-h1"
                                theme={{
                                    '&:hover': {
                                        textDecoration: 'underline'
                                    },
                                    color: '#006fcf'
                                }}
                            >
                                Hide Details
                            </CollapsibleHeading>
                        </p>
                    </CollapsibleContent>
                </Collapsible>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <Label htmlFor="smartfield" className="label-1">Create a 4-digit Card Personal Identification Number</Label>
                    <PasswordInput id="pin" 
                    required={true}
                        maxLength={4}
                        minLength={4}
                        onBlur={handlePinBlur}
                        onKeyPress={pinKeyPressHandler}
                    />
                    <Alert id="Pin-alert" show={errorData.cardPinRequired}>Please enter a 4-digit code as your Card Account PIN.</Alert>
                </div>
                <div className="col-md-6">
                    <Label htmlFor="smartfield" className="label-1">Confirm a 4-digit Card Personal Identification Number</Label>
                    <PasswordInput id="confirmPin"  
                        required={true}
                        maxLength={4}
                        minLength={4}
                        onBlur={handleCPinBlur}
                        onKeyPress={pinKeyPressHandler}
                    />
                    <Alert id="CPin-alert" show={errorData.confirmCardPinRequired}>Please confirm your 4-digit code and ensure it matches.</Alert>
                </div>    
            </div>
        </div>
    );
}
export default CardPin;